import { cn } from "$/lib/utils/functions/misc.functions";

import type { TimePickerProps } from "../TimePicker.types";

const NumberInputClassName =
  "h-8 w-11 rounded-md border-none bg-tertiary-400 text-center outline-none focus:border focus:border-primary focus:bg-white";
const NumberInputSpinnerClassName =
  "[&::-webkit-inner-spin-button]:m-0 [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:m-0 [&::-webkit-outer-spin-button]:appearance-none";

export const Option1 = ({ value, onChange }: TimePickerProps) => {
  return (
    <>
      <input
        className={cn(NumberInputClassName, NumberInputSpinnerClassName)}
        type="number"
        min={1}
        max={12}
        value={value.hours}
        onChange={(e) => {
          const newValue = parseInt(e.target.value);
          if (Number.isNaN(newValue) || newValue <= 12)
            onChange({
              ...value,
              hours: newValue,
            });
        }}
      />

      <span className="font-bold">:</span>

      <input
        className={cn(NumberInputClassName, NumberInputSpinnerClassName)}
        type="number"
        min={0}
        max={60}
        value={value.minutes}
        onChange={(e) => {
          const newValue = parseInt(e.target.value);
          if (Number.isNaN(newValue) || newValue <= 60)
            onChange({
              ...value,
              minutes: newValue,
            });
        }}
      />

      <div className="flex gap-0 transition-all duration-200">
        <button
          className={cn("m-0 h-8 w-11 rounded-bl-md rounded-tl-md", {
            "border-0 bg-primary text-white": value.period === "am",
            "border border-r-0 border-gray-200 bg-white": value.period === "pm",
          })}
          onClick={() =>
            onChange({
              ...value,
              period: value.period === "am" ? "pm" : "am",
            })
          }
        >
          AM
        </button>
        <button
          className={cn("m-0 h-8 w-11 rounded-br-md rounded-tr-md", {
            "bg-primary text-white": value.period === "pm",
            "border border-l-0 border-gray-200 bg-white": value.period === "am",
          })}
          onClick={() =>
            onChange({ ...value, period: value.period === "am" ? "pm" : "am" })
          }
        >
          PM
        </button>
      </div>
    </>
  );
};
